enum LeftPanelType {
    HOME = 'HOME',
    RECENTS = 'RECENTS',
    FAVORITES = 'FAVORITES',
    NEW = 'NEW',
}

export default LeftPanelType;
